import * as actionTypes from './types';

const INITIAL_KEY_STATE: any = {
    result: null,
    current: null,
    isLoading: false,
    isSuccess: false,
};

const INITIAL_STATE: any = {
    current: {
        result: null,
    },
    list: {
        result: {
            items: [],
            pagination: {
                current: 1,
                pageSize: 5,
                total: 1,
                showSizeChanger: false,
            },
        },
        isLoading: false,
        isSuccess: false,
    },
    create: INITIAL_KEY_STATE,
    update: INITIAL_KEY_STATE,
    delete: INITIAL_KEY_STATE,
    read: INITIAL_KEY_STATE,
    search: { ...INITIAL_KEY_STATE, result: [] },
};

const policyCollectionsReducer = (state = INITIAL_STATE, action: any) => {
    const { payload, keyState } = action;

    // Ensure that the keyState exists in the state, initialize it if not
    const stateForKey = state[keyState] || { ...INITIAL_KEY_STATE };

    switch (action.type) {
        case actionTypes.POLICYCOLLECTIONS_RESET_STATE:
            return INITIAL_STATE;

        case actionTypes.POLICYCOLLECTIONS_CURRENT_ITEM:
            return {
                ...state,
                current: {
                    result: payload,
                },
            };

        case actionTypes.POLICYCOLLECTIONS_REQUEST_LOADING:
            return {
                ...state,
                [keyState]: {
                    ...stateForKey,
                    isLoading: true,
                },
            };

        case actionTypes.POLICYCOLLECTIONS_REQUEST_FAILED:
            return {
                ...state,
                [keyState]: {
                    ...stateForKey,
                    isLoading: false,
                    isSuccess: false,
                },
            };

        case actionTypes.POLICYCOLLECTIONS_REQUEST_SUCCESS:
            return {
                ...state,
                [keyState]: {
                    ...stateForKey,
                    result: payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };

        case actionTypes.POLICYCOLLECTIONS_CURRENT_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...stateForKey,
                    current: payload,
                },
            };

        case actionTypes.POLICYCOLLECTIONS_RESET_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...INITIAL_STATE[keyState],
                },
            };

        default:
            return state;
    }
};

export default policyCollectionsReducer;
